<template>
  <section>
    <el-row class="warp">
      <el-col :span="6" class="warp-breadcrum">
          <el-breadcrumb separator="/">
          <!--
            <el-breadcrumb-item :to="{ path: '/' }">
              <b>首页</b>
            </el-breadcrumb-item>
            -->
            <el-breadcrumb-item>整期数据上传列表</el-breadcrumb-item>
          </el-breadcrumb>
      </el-col>
    </el-row>  

      <!--工具条 begin-->
    <el-row class="warp">
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
              <el-form-item label="期刊：" prop="journalName">
                  <el-select v-model="searchForm.journalId" filterable  placeholder="请选择期刊" @change="journalSelectChanged">
                      <el-option
                      v-for="item in journals"
                      :key="item.journalId"
                      :label="item.journalName"
                      :value="item.journalId"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="年份：" prop="yearValue">
                  <el-date-picker
                      v-model="searchForm.yearValue"
                      type="year"
                      value-format="yyyy"
                      placeholder="选择年"
                      @change="yearChanged">
                  </el-date-picker>
              </el-form-item>
              <el-form-item>
              <el-row>
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                  <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="上传权限：" v-if="notProcess" prop="label">
                        <el-select v-model="searchForm.flag" filterable placeholder="请选择自动转换类型" @change="optionChanged">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" type="primary" @click="findResult(null)">查询</el-button>
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" type="primary" @click="refresh(null)">刷新</el-button>
              </el-form-item>
              <el-form-item>
                  <el-button size="mini" type="primary" @click="addSupplement(null)">添加增刊</el-button>
              </el-form-item>
          </el-form>
      </el-col>
    </el-row>
      <!-- 
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-upload
              class="upload-demo"
              ref="upload"
              :action="packageUrl(flag)"
              accept="zip"
              :limit="1"
              :file-list="fileList"
              :on-success="uploadApkSuccess"
              :auto-upload="false"
              >
              <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
              <div slot="tip" class="el-upload__tip">只能上传zip文件</div>
          </el-upload>
      </el-col>
      --> 
      <!--工具条 end-->
    <el-row>
      <!-- 列表显示 begin-->
      <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
        <el-table :data="issueList" style="width: 100%;overflow: auto;" stripe highlight-current-row v-loading="tableLoading" class="tablebar">
          <!-- 第一行显示数据 -->
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column prop="journalName" label="期刊" sortable align="center"></el-table-column>
          <el-table-column prop="issn" label="Issn" sortable align="center"></el-table-column>
          <el-table-column prop="year" label="年/Year" sortable align="center"></el-table-column>
          <el-table-column prop="issue" label="期/Issue" sortable align="center"></el-table-column>
          <el-table-column prop="totalNum" label="文章总数" sortable align="center"></el-table-column>
          <el-table-column prop="articleCount" label="已发布文章数" sortable align="center"></el-table-column>
          <el-table-column prop="errorNum" label="失败文章数" sortable align="center"></el-table-column>
          <el-table-column prop="dueDay" label="过期时间" sortable align="center"></el-table-column>
          <el-table-column prop="uploadStatus" label="状态" sortable align="center">
            <template slot-scope="scope">
                <el-tag
                    :type="scope.row.uploadStatus === 2 || scope.row.uploadStatus === 4 ? 'success' : 'danger'"
                    disable-transitions>
                    {{scope.row.uploadInfo}}
                </el-tag>
              </template>
          </el-table-column>
          <!-- 上传按钮 -->
          <el-table-column label="上传" width="100" align="center">
            <template slot-scope="scope">
              <el-upload
                  class="upload-demo"
                  :ref="uploadDemo + scope.$index"
                  :action="packageUrl(searchForm.flag,scope.row)"
                  :limit="1"
                  :file-list="fileList"
                  :on-success="uploadApkSuccess"
                  :before-upload="beforeUpload"
                  :auto-upload="false"
                  :on-change="changeFile"
                  >
                  <el-button size="small" type="success" @click="uploadClick(scope.$index)" :style="(scope.row.uploadStatus === 1) ? { display: 'none' } : { display: '' }">点击上传</el-button>
              </el-upload>
            </template>
          </el-table-column>
          <!-- 下载原始数据 -->
          <!-- <el-table-column label="操作" width="240" align="center">
            <template slot-scope="scope">
              
            </template>
          </el-table-column> -->
          <!-- 操作按钮 -->
          <el-table-column label="操作" minWidth="100" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" :style="(scope.row.uploadStatus === 1) ? { display: '' } : { display: 'none' }" @click="showProcess(scope.$index, scope.row)">查看进度</el-button>
              <el-button type="primary" size="mini" :style="((scope.row.uploadStatus === 2 || scope.row.uploadStatus === 4)) ? { display: '' } : { display: 'none' }" @click="downloadProcessData(scope.$index, scope.row)">下载源数据</el-button>
            <!--  <el-button type="primary" size="mini" :style="((scope.row.uploadStatus === 2 || scope.row.uploadStatus === 4) && notProcess) ? { display: '' } : { display: 'none' }" @click="showInfo(scope.$index, scope.row)">查看详情</el-button> -->
              <el-button type="primary" size="mini" :style="((scope.row.uploadStatus === 2 || scope.row.uploadStatus === 4)) ? { display: '' } : { display: 'none' }" @click="showInfo(scope.$index, scope.row)">查看详情</el-button>
              <el-button type="danger" size="mini" :style="(scope.row.uploadStatus === 3 || scope.row.errorNum > 0) ? { display: '' } : { display: 'none' }" @click="showErroInfo(scope.$index, scope.row)">失败详情</el-button>
              <el-button type="danger" size="mini" :style="(!notAdmin) ? { display: '' } : { display: 'none' }" @click="deleteIssue(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <div slot="empty" class="empty">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </el-table>
      </el-col>
      <!-- 列表显示 end-->
      <!--新增对话框界面 begin-->
      <el-dialog title="进度查询" :visible.sync="processDialogVisible" :close-on-click-modal="false">
        <div style="text-align:center;">
          <span>{{processInfo}}</span>
        </div>
        <div slot="footer" class="dialog-footer" align="center">
            <el-progress type="circle" :percentage="processPercent"></el-progress>
        </div>
        <!-- 创建form 
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
        -->
      </el-dialog>
      <!-- 新增对话框界面 end -->

      <el-dialog title="失败列表" :visible.sync="errorTableVisible">
        <el-table :data="errorData">
          <el-table-column property="fileName" label="文件名称" width="150"></el-table-column>
          <el-table-column property="errorInfo" label="错误信息" width="600"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="downLoad(scope.$index, scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!-- -->
      <el-dialog title="加工数据详情" :visible.sync="processDataVisible">
        <el-table :data="processDataInfo">
          <el-table-column property="fileName" label="文件名称" width="150"></el-table-column>
          <el-table-column property="filePath" label="文件路径" width="600"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="downLoad(scope.$index, scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog title="添加增刊" :visible.sync="addFormVisible" :close-on-click-modal="false" v-loading="supportLoading">
        <el-form :model="dynamicValidateForm" label-width="100px" ref="dynamicValidateForm" class="demo-dynamic">
          <!-- 创建form -->
          <el-form-item
            v-for="(support, index) in dynamicValidateForm.supports"
            :label="'增刊' + (index+1)"
            :key="support.key"
            :prop="'supports.' + index + '.value'"
            :rules="{
              required: true, message: '增刊不能为空', trigger: 'blur'
            }"
          >
            <el-input v-model="support.value" style="width:80%"></el-input>
            <el-button size="mini" @click.prevent="removeSupport(support)" style="margin-left:10px">删除</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
            <el-button @click="close('dynamicValidateForm')">取消</el-button>
            <el-button type="warning" @click="addSupport">新增</el-button>
            <el-button type="primary" @click="submitForm('dynamicValidateForm')" :loading="supportLoading">提交</el-button>
          </div>
      </el-dialog>
    </el-row>
  </section>
</template>

<script>
import API_LOG from "../../../api/api_log";
import API_JOURNAL from "../../../api/api_journal";
import API_JOURNALDATA from "../../../api/api_journalData";

export default {
  data() {
    return {
        options: [],
        searchForm:{
          journalId:"",
          yearValue:"2022",
          //上传的转换类型，0代表不转换，1代表仁和，2代表玛格
          flag: '',
          audit:'',
        },
        //已选择的转换类型名称
        selectedLabel:"",
        selectedIssueId:"",
        uploadDemo:"uploadDemo",
        uploadName:"",
        processDataInfo:[],
        processDataVisible:false,
        journals:[],
        issueList: [],
        errorData:[],
        errorTableVisible:false,
        notProcess:true,
        notAdmin:true,
        
        processDialogVisible:false,
        processPercent:0,
        processInfo:"文件上传后台处理中。。。",
        totleNum:0,
        currentNum:0,

        //页面载入状态
        tableLoading: false,
        fileList: [],
        timer:null,
        //添加增刊
        addFormVisible: false, //新增界面是否显示
        supportLoading: false,
        dynamicValidateForm: {
          supports: [{
            value: ''
          }],
        },

      //在此添加新的数据定义
    };
  },

  methods: {
    //获取所有期刊
    async findJournalList(){
        let that = this;
        await API_JOURNAL.getJournalList()
        .then(res=>{
            if(res && res.journal){
              that.journals = Object.values(res.journal);
              that.getRefJournalUploadTypeOptionsByJournal(that.journals[0].journalId);
              if(that.searchForm.journalId == undefined  || that.searchForm.yearValue == undefined ){
                //console.log("新界面");
                //新界面，取数组的第一个展示
                that.searchForm.journalId = that.journals[0].journalId;
                that.searchForm.audit = that.journals[0].audit;

                //获取当前年份
                let year = new Date().getFullYear();
                //console.log("year:",year);
                that.searchForm.yearValue = year;
                that.findResult();
              }
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求findJournalByInsId()出现异常",
            duration:2000
            });
        });
    },

    findJournalByJournalId(_journalId){
        let that = this;
        let params = {
            journalId: _journalId
        };
        API_JOURNAL.getJournal(params)
        .then(res=>{
            if(res && res.journalName){
              that.findJournalList().then(function(){
                that.searchForm.journalId = res.journalId;
                that.getRefJournalUploadTypeOptionsByJournal(res.journalId);
                that.searchForm.audit = res.audit;
                that.findResult();
              });
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求findJournalByJournalId()出现异常",
            duration:2000
            });
        });
    },

    journalSelectChanged(value){
        this.findJournalByJournalId(value);
    },

    optionChanged(value){
      console.log("optionChanged value:"+value);
        if(value){
          let obj = {};
          obj = this.options.find(item =>{
            return item.value === value;
          })
          this.selectedLabel = obj.label;
          console.log("selectedLabel:"+this.selectedLabel);
        }
        else{
          this.selectedLabel = "";
        }
    },

    yearChanged(value){
      this.refresh();
    },

    findResult(){
      let that = this;
      this.tableLoading = true
      let params = {
        yearValue: that.searchForm.yearValue,
        journalId: that.searchForm.journalId,
      };
      //console.log("......findResult params:" + JSON.stringify(params));
      //发送http请求
      API_JOURNALDATA.getJournalIssueList(params)
        .then(res => {
            if(res && res.issueList){
                that.issueList = Object.values(res.issueList);
                /*console.log(
                    "......findResult:" + JSON.stringify(that.issueList)
                );
                */
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求findResult()出现异常",
            duration: 2000
          });
        }).finally(()=>{
          this.tableLoading = false
        });;
    },

    deleteIssue(index, row){
      const h = this.$createElement;
      this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('span', null, '请确定是否删除第：'),
            h('span', { style: 'color: red' }, row.issue),
            h('span',null,' 期?')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          let that = this;
          let params = {
            id: row.issueId,
          };
          API_JOURNALDATA.deleteJournalData(params)
            .then(res => {
                if(res && res.errorCode === 0){
                    console.log(
                        "......deleteJournalData successful" );
                }
                else{
                  that.$message({
                      showClose: true,
                      message: res.errorInfo,
                      type: "error"
                    });
                }
                that.refresh();
            })
            .catch(e => {
              this.$message({
                showClose: true,
                type: "error",
                message: "请求deleteJournalData()出现异常",
                duration: 2000
              });
            });
        }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '删除失败'
            // });
        });
      
    },

    packageUrl(flag,row)
    {
      //debugger;
      let roles = sessionStorage.getItem('roles');
      if(roles.indexOf('process') >= 0){
        //数据加工的flag必须是3，数据加工上传的必须是sciengine的包
        flag = '3';
      }
      return  "api/journalData/fileUpload?flag="+flag+"&listId="+row.issueId;
    },

    changeFile(file){
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024);
      if (imgSize > 2000) {
        this.$msgbox({
          title: "",
          message: "文件大小不能超过2GB,请重新选择符合要求的文件上传。",
          type: "warning",
        });
        let dl = this.fileList.indexOf(file);
        this.fileList.splice(dl, 1);
        return;
      } 

      let testmsg=file.name.substring(file.name.lastIndexOf('.')+1);
      let extension1=testmsg==='zip'
      let extension2=testmsg==='rar'
      let extension3=testmsg==='7z'
      if (!extension1 && !extension2 && !extension3) {
        this.$msgbox({
          title: "",
          message: "上传文件只能是zip/rar/7z格式,请重新选择符合要求的文件上传。",
          type: "warning",
        });
        let dl = this.fileList.indexOf(file);
        this.fileList.splice(dl, 1);
        return;
      };

      if(file.status == 'ready'){
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('span', null, '请确定是否上传：'),
            h('i', { style: 'color: red' }, this.selectedLabel),
            h('span',null,' 类型的文件?')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.submitUpload();
        }).catch(() => {
            this.$refs[`${this.uploadName}`].clearFiles();
            this.$message({
              type: 'info',
              message: '取消文件上传'
            });
        });
      }
    },

    uploadClick(index){
      console.log("uploadClick index:"+index);
      console.log("uploadClick refs",this.$refs);
      this.uploadName = "uploadDemo"+index;
    },

    submitUpload() {
      console.log(this.$refs[`${this.uploadName}`]);
      console.log("submitUpload:" + this.uploadName);
      
      this.$refs[`${this.uploadName}`].submit();
    },

    beforeUpload(){
      this.tableLoading = true;  
    },

    uploadApkSuccess(response, fileList) {
      if(response.errorCode != 0)
      {
          this.$message({
          showClose: true,
          type: "info",
          message: response.errorInfo,
          duration: 2000
        });
        this.fileList= [];
        this.tableLoading = false;
        return;
      }
      else{
        this.fileList= [];
        this.searchForm.journalId = response.journalId;
        this.searchForm.yearValue = response.year;
        this.tableLoading = false;
        this.findResult();
      }
    },

    //显示编辑对话框
    showInfo: function(index, row) {
      if(row.uploadStatus === 2){
        this.$router.push({
                path: '/resultMng/issueData', 
                query: {journalName: row.journalName, issn: row.issn, year: row.year, issue: row.issue, 
                journalId: this.searchForm.journalId, audit: row.audit}})
      }
      else{
        //
        this.getProcessDataInfoByPrimaryId(row.issueId);
      }
      
    },

    getProcessDataInfoByPrimaryId:function(id){
      let that = this;
      let params = {
        id: id,
      };
      //发送http请求
      API_JOURNALDATA.getProcessDataInfoByPrimaryId(params)
        .then(res => {
            if(res && res.errorCode === 0){
                that.processDataInfo = Object.values(res.processDataInfo);
                that.processDataVisible = true;
            }
            else{
              that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                });
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求getProcessDataInfoByPrimaryId()出现异常",
            duration: 2000
          });
        });
    },

    dataInit(){
      let that = this;
      let roles = sessionStorage.getItem('roles');
      //console.log('roles:' + roles);
      if(roles.indexOf('process') >= 0){
        that.notProcess = false;
      }
      if(roles.indexOf('admin') >= 0){
        that.notAdmin = false;
      }
      that.searchForm.yearValue = this.$route.query.yearValue;
      that.searchForm.journalId = this.$route.query.journalId;
      this.findResult();
    },

    refresh(){
      this.findResult();
    },

    showProcess(index, row){
      this.getProcessDetailByPrimaryId(row.issueId);
    },

    getProcessDetailByPrimaryId:function(id){
      let that = this;
      let params = {
        id: id,
      };
      //发送http请求
      API_JOURNALDATA.getProcessDetail(params)
        .then(res => {
            if(res && res.errorCode === 0){
                that.processPercent = res.processPercent;
                that.processInfo = res.processInfo;
                that.processDialogVisible = true;
            }
            else{
              that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                });
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求getProcessDetailByPrimaryId()出现异常",
            duration: 2000
          });
        });
    },

    showErroInfo(index, row){
      this.getErrorDetailByPrimaryId(row.issueId);
    },

    getErrorDetailByPrimaryId:function(id){
      let that = this;
      let params = {
        id: id,
      };
      //发送http请求
      API_JOURNALDATA.getErrorDataByIssueList(params)
        .then(res => {
            if(res && res.errorCode === 0){
                that.errorData = Object.values(res.ErrorDataList);
                that.errorTableVisible = true;
            }
            else{
              that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                });
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求getErrorDetailByPrimaryId()出现异常",
            duration: 2000
          });
        });
    },
    getRefJournalUploadTypeOptionsByJournal(journalId){
        let that = this;
        let params = {
            journalId: journalId
        };
        API_JOURNAL.getRefJournalUploadTypeOptionsByJournal(params)
        .then(res=>{
            if(res && res.uploadTypeList){
              that.options = res.uploadTypeList;
              that.searchForm.flag = that.options[0].value;
              that.selectedLabel = that.options[0].label;
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求getRefJournalUploadTypeOptionsByJournal()出现异常",
            duration:2000
            });
        });
    },

    
    downloadProcessData(index,row){
      let that = this;
      let params = {
        transUrl: row.processDataPath
      };
      API_LOG.downloadZip(params)
        .then(res => {
          if (navigator.userAgent.match(/MSIE\s([\d.]+)/) ||navigator.userAgent.indexOf("Trident") > -1) {
                window.navigator.msSaveBlob(res, row.processDataName);
          } 
          else {
            const blob = new Blob([res]);
            const fileName = row.processDataName;
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', processDataName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        });
    },

    downLoad: function(index, row) {
      //console.log("........downLoad:" + JSON.stringify(row));
      let that = this;
      let params = {
        transUrl: row.filePath
      };
      API_LOG.downloadZip(params)
        .then(res => {
          if (navigator.userAgent.match(/MSIE\s([\d.]+)/) ||navigator.userAgent.indexOf("Trident") > -1) {
                window.navigator.msSaveBlob(res, row.fileName);
          } 
          else {
            const blob = new Blob([res]);
            const fileName = row.fileName;
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        });
    },


    //添加增刊
    addSupplement(){
      let that = this;
      that.addFormVisible = true;
    },

    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
              year: that.searchForm.yearValue,
              journalId: that.searchForm.journalId,
              supplementList:that.dynamicValidateForm.supports
          };

          that.supportLoading = true;
          console.log(
              ".........supplement add by params:" + JSON.stringify(params)
          );
          //发送http请求
          API_JOURNALDATA.addSupplementIssue(params)
              .then(res => {
              if (0 === res.errorCode) {
                  that.$message({
                  type: "success",
                  message: "添加增刊成功!"
                  });

                  //创建成功后，刷新列表显示
                  this.close(formName);
              } else {
                  that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                  });
              }
              that.supportLoading = false;
              })
              .catch(e => {
              that.$message({
                  showClose: true,
                  type: "error",
                  message: "请求出现异常",
                  duration: 2000
              });
              that.supportLoading = false;
              });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    addSupport() {
      this.dynamicValidateForm.supports.push({
        value: '',
        key: Date.now()
      });
    },

    removeSupport(item) {
      var index = this.dynamicValidateForm.supports.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.supports.splice(index, 1)
      }
    },

    close(formName){
      this.$refs[formName].resetFields();
      this.addFormVisible = false;
      this.refresh();
    }

  },
  mounted() {
    const timer = setInterval(()=>{
      this.refresh()
    },20000) //每10秒执行1次
    //通过$once来监听定时器，在beforeDestroy钩子可以被清除
    this.$once('hook:beforeDestroy',()=>{
      //在页面销毁时，销毁定时器
      clearInterval(timer)
    })
  },
  created(){
    this.dataInit();
    
    this.findJournalList();
  },
  watch:{
    "searchForm.yearValue"(val){
      this.searchForm.yearValue = "" + val;
    }
  }
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Data/DataManage.vue